import gql from 'graphql-tag'
import { getProvider } from '@/apollo'
import { splitError } from '@/helper/splitError'

const initialState = {
  contractSummaryInfo: {
    contractSummaryId: null,
    confirmationStatus: null,
    deferredCSInfo: {
      expiryDate: null
    }
  },
  cSError: false,
  contractId: null,
  status: null,
  expired: null,
  expiredLinkUrl: null,
  alreadyLinkUrl: null,
  process: null,
  errorMessage: null,
  contractSummaryConfirmSuccess: false
}

const ContractSummaryModule = {
  namespaced: true,
  state: initialState,
  getters: {
    errorMessage: (state) => {
      return state.errorMessage
    },
    contractSummaryInfo: (state) => {
      return state.contractSummaryInfo
    },
    contractSummaryConfirmSuccess: (state) => {
      return state.contractSummaryConfirmSuccess
    },
    contractId: (state) => {
      return state.contractId
    },
    expired: (state) => {
      if (state.contractSummaryInfo.deferredCSInfo !== null && state.contractSummaryInfo.deferredCSInfo.expiryDate !== undefined) {
        return (new Date() > Date.parse(state.contractSummaryInfo.deferredCSInfo.expiryDate))
      } else if (state.status === 'TIMED_OUT') {
        return true
      }
      return false
    },
    confirmationStatus: (state) => {
      return state.contractSummaryInfo.confirmationStatus
    },
    expiredLinkUrl: (state) => {
      return state.expiredLinkUrl
    },
    alreadyLinkUrl: (state) => {
      return state.alreadyLinkUrl
    },
    process: (state) => {
      return state.process
    },
    showCSError: (state) => {
      return state.cSError
    }
  },
  mutations: {
    contractSummaryInfo: (state, contractSummaryInfo) => {
      state.contractSummaryInfo = contractSummaryInfo
    },
    contractSummaryConfirmSuccess: (state, contractSummaryConfirmSuccess) => {
      state.contractSummaryConfirmSuccess = contractSummaryConfirmSuccess
    },
    contractId: (state, contractId) => {
      state.contractId = contractId
    },
    confirmationStatus: (state, confirmationStatus) => {
      state.contractSummaryInfo.confirmationStatus = confirmationStatus
    },
    status: (state, status) => {
      state.status = status
    },
    setExpiredLinkUrl: (state, expiredLinkUrl) => {
      state.expiredLinkUrl = expiredLinkUrl
    },
    setAlreadyLinkUrl: (state, alreadyLinkUrl) => {
      state.alreadyLinkUrl = alreadyLinkUrl
    },
    setProcess: (state, process) => {
      state.process = process
    },
    errorMessage: (state, errorMessage) => {
      state.errorMessage = errorMessage
    },
    setCSError: (state, show) => {
      state.cSError = show
    },
    resetState (state) {
      Object.assign(state, initialState)
    }
  },
  actions: {
    contractSummaryStatus ({ commit, state }, { processId }) {
      const apolloClient = getProvider().defaultClient
      return apolloClient.query({
        query: gql`query contractSummary($brand: String!, $processId: String!){
          contractSummaryStatus(contractSummaryStatus: {
            brand: $brand,
            processId: $processId
          }) {
            contractId
            status
            contractSummaryInfo {
              contractSummaryId
              confirmationStatus
              deferredCSInfo {
                expiryDate
              }
            }
          }
        }`,
        variables: {
          brand: 'simon',
          processId: processId
        }
      }).then((response) => {
        commit('contractSummaryInfo', response.data.contractSummaryStatus.contractSummaryInfo)
        commit('contractId', response.data.contractSummaryStatus.contractId)
        if (state.contractSummaryInfo.confirmationStatus === null) { // falls confirmationStatus nicht gesetzt (zB bei OPTION_BOOKING) wird der contractSummaryStatus.status gemapt
          const status = response.data.contractSummaryStatus.status
          if (status === 'PENDING_CONFIRM' || status === 'PENDING_DEFERRED_CONFIRM') {
            commit('confirmationStatus', 'WAI')
          } else if (status === 'ACTIVE') {
            commit('confirmationStatus', 'CON')
          } else {
            commit('confirmationStatus', 'NON')
          }
        }
        return response.data.contractSummaryStatus
      }).catch((error) => {
        commit('errorMessage', splitError(error)[0].message)
        return splitError(error)[0].message
      })
    },
    contractSummaryDeferredConfirm ({ commit, getters, state }, { processId }) {
      const apolloClient = getProvider().defaultClient
      return apolloClient.mutate({
        mutation: gql`mutation contractSummary($brand: String!, $processId: String!,
          $contract: DeferredContractInput!){
          contractSummaryDeferredConfirm(contractSummaryDeferredConfirm: {
            brand: $brand, processId: $processId, contract: $contract
          }) {
            success
          }
        }`,
        variables: {
          brand: 'simon',
          processId: processId,
          contract: {
            confirmed: true
          }
        }
      }).then((response) => {
        commit('contractSummaryConfirmSuccess', response.data.contractSummaryDeferredConfirm.success)
        return response.data.contractSummaryDeferredConfirm.success
      }).catch((error) => {
        commit('errorMessage', splitError(error)[0].message)
        return splitError(error)[0].message
      })
    }
  }
}

export {
  ContractSummaryModule
}
